import { makeStyles } from "@mui/styles";
import { BaseThemeOptions } from "themes/base";

export const useStyles = makeStyles((theme: BaseThemeOptions) => ({
	sectionBar: {
		width: "4px",
		borderRadius: "10px",

		"&.forecast": {
			background: theme.palette.primary.main,
		},

		"&.forecastBenchmark": {
			background: theme.palette.warning.main,
		},
	},
}));
